import { useInstructorColor } from "context/InstructorColorProvider";
import { colors } from "shared/theme/color";
import { textPx } from "shared/constants/zoom";

// Initials from a name: first letter of the first two words, uppercased.
const initials = (name?: string) =>
  (name ?? "")
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0] ?? "")
    .join("")
    .toUpperCase();

// Round instructor avatar tinted from the shared instructor palette — the same
// source the calendar event blocks use, so an instructor reads identically in
// both Kalender and Daftar. Falls back to a neutral chip when uncoloured.
export const InstructorAvatar = ({
  instructorId,
  name,
  size = 28,
}: {
  instructorId?: string;
  name?: string;
  size?: number;
}) => {
  const { getInstructorColorById } = useInstructorColor();
  const color = instructorId ? getInstructorColorById(instructorId) : undefined;

  return (
    <span
      style={{
        width: size,
        height: size,
        borderRadius: 999,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        fontWeight: 600,
        fontSize: textPx(10.5),
        background: color?.bg ?? colors.bgSoft,
        color: color?.text ?? colors.ink2,
      }}
    >
      {initials(name)}
    </span>
  );
};
